var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{attrs:{"closable":_vm.retryable,"close-text":_vm.$t('ACTIONS.RETRY'),"description":_vm.description,"title":_vm.label,"type":_vm.type,"effect":"dark","show-icon":""},on:{"close":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }